export default __webpack_public_path__ + "static/media/Meet your kind of people.7d7dd114.webp";